import React, { useState } from 'react';
import { CONTACT_EMAIL } from '../constants';
import { createMailtoLink } from '../utils';

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Create email content
    const emailSubject = formData.subject || 'Contact Form Submission from Lokvir Impex Website';
    const emailBody = `Hello,

You have received a new message from the Lokvir Impex website contact form:

Name: ${formData.name}
Email: ${formData.email}
Subject: ${formData.subject}

Message:
${formData.message}

---
This message was sent from the Lokvir Impex website contact form.`;

    // Create mailto link
    const mailtoLink = createMailtoLink(CONTACT_EMAIL, emailSubject, emailBody);
    
    // Open email client
    window.location.href = mailtoLink;
    
    // Show success message
    alert('Your email client will open with the message ready to send!');
    
    // Reset form after a short delay to allow the email client to open
    setTimeout(() => {
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    }, 1000);
  };

  return (
    <form onSubmit={handleSubmit}>
      {/* Name Field */}
      <div className="flex flex-wrap items-end gap-4 py-3">
        <label className="flex flex-col min-w-40 flex-1">
          <input
            name="name"
            placeholder="Your Name"
            className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-[#151b0e] focus:outline-0 focus:ring-0 border-none bg-[#eef3e7] focus:border-none h-14 placeholder:text-[#79974e] p-4 text-base font-normal leading-normal"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </label>
      </div>

      {/* Email Field */}
      <div className="flex flex-wrap items-end gap-4 py-3">
        <label className="flex flex-col min-w-40 flex-1">
          <input
            name="email"
            type="email"
            placeholder="Your Email"
            className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-[#151b0e] focus:outline-0 focus:ring-0 border-none bg-[#eef3e7] focus:border-none h-14 placeholder:text-[#79974e] p-4 text-base font-normal leading-normal"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </label>
      </div>

      {/* Subject Field */}
      <div className="flex flex-wrap items-end gap-4 py-3">
        <label className="flex flex-col min-w-40 flex-1">
          <input
            name="subject"
            placeholder="Subject"
            className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-[#151b0e] focus:outline-0 focus:ring-0 border-none bg-[#eef3e7] focus:border-none h-14 placeholder:text-[#79974e] p-4 text-base font-normal leading-normal"
            value={formData.subject}
            onChange={handleInputChange}
            required
          />
        </label>
      </div>

      {/* Message Field */}
      <div className="flex flex-wrap items-end gap-4 py-3">
        <label className="flex flex-col min-w-40 flex-1">
          <textarea
            name="message"
            placeholder="Your Message"
            className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-[#151b0e] focus:outline-0 focus:ring-0 border-none bg-[#eef3e7] focus:border-none min-h-36 placeholder:text-[#79974e] p-4 text-base font-normal leading-normal"
            value={formData.message}
            onChange={handleInputChange}
            required
          />
        </label>
      </div>

      {/* Submit Button */}
      <div className="flex py-3">
        <button
          type="submit"
          className="flex min-w-[84px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-10 px-4 flex-1 bg-[#9be830] text-[#151b0e] text-sm font-bold leading-normal tracking-[0.015em] hover:bg-[#8bd020] transition-colors"
        >
          <span className="truncate">Send Message</span>
        </button>
      </div>
    </form>
  );
}
